// extracted by mini-css-extract-plugin
export var container = "pages-account-__PurchaseCharlieCardCcForm-module___container";